<template>
  <div id="times-2">
    <BaseBanner v-bind="bannerProps" @onLoaded="onLoaded"></BaseBanner>

    <main
      class="content"
      :style="{ 'background-image': `url(${background.mainBg})` }"
    >
      <template v-if="timelines && timelines.length > 0">
        <ul class="times">
          <TimelineItem
            v-for="(time, index) in visibleTimelines"
            :key="time.id"
            :timeline="time"
            :index="index"
            :is-unlocked="isUnlocked(time)"
            :is-found="!progress.includes(time.id)"
            :node-icon="getNodeIcon()"
            :line-icon="icon.line"
            :lock-icon="icon.lockTime"
            :find-clue-icon="icon.findClue"
            :timeline-content="timelineContent(time)"
            @find-clue="findClue"
          />
        </ul>
      </template>
      <template v-else>
        <p class="content__text">
          幽倩今日公休
        </p>
      </template>
    </main>
    <SelectedOptions
      :timeline="currentTimeline"
      :backgroundUrl="background.mainBg"
      :isCardModalActive="isCardModalActive"
      :listStyleUrl="icon.findClue"
      @hideOptions="hideOptions"
      @selectedOption="selectedOption"
    />
  </div>
</template>

<script>
import BaseBanner from '../../shared/baseBanner';
import TimelineItem from './components/TimelineItem.vue';
import SelectedOptions from './components/SelectedOptions.vue';
import { useTimesPage } from './useTimesPage';

/**
 * Times page using composition API with extracted components
 * - TimelineItem: Individual timeline entry display
 * - SelectedOptions: Modal for answer selection (with fixed shuffle)
 */
export default {
  name: 'TimesPage',

  components: {
    BaseBanner,
    TimelineItem,
    SelectedOptions
  },

  props: ['memberLineId', 'memberName', 'groupId', 'updateGroupStoryShip', 'updateFinishedDemo'],

  setup(props) {
    return useTimesPage(props);
  }
};
</script>

<style lang="scss" scoped src="./style.scss"></style>
